// routes/PrivateRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "../constants/routes";

interface PrivateRouteProps {
	isAuthenticated: boolean;
	children: React.ReactElement;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
	isAuthenticated,
	children,
}) => {
	return isAuthenticated ? children : <Navigate to={ROUTES.HOME} replace />;
};
